<template>
    <div>
        <div class="AdBlock Ad-Top" v-if="GetTheme.length > 0">
            <div>
                <div class="AdTheme-Title"> {{ GetTheme[0].NumsIndex + '. ' + $t("lbl_EMPBE_Ad_SRIsBelow") + " - " +
                    $t('lbl_EMPBE_Ad_Theme') }} </div>
                <span v-for="(item, index) in GetTheme" class="AdTheme-Value"
                    :key="GetTheme.searchId + '_' + index">{{ item.text }}</span>
            </div>
            <div class="AdPosition Ad-Top " v-if="GetPositions.keyword && GetPositions.keyword.length > 0">
                <div class="AdPosition-Title">{{ $t('lbl_EMPBE_Ad_Position') }}</div>
                <span class="AdPosition-Value" v-for="(item, index) in GetPositions.keyword" :key="item+'_index_'+index">
                    #{{ item }}
                    <span v-if="index < GetPositions.keyword.length - 1">
                        /
                    </span>
                </span>
            </div>
        </div>
        <div class="AdOrText Ad-Top" v-if="GetTheme.length > 0 && MoreThenIndex(GetTheme[0].NumsIndex)">
            {{ $t('lbl_EMPBE_Ad_Or') }} </div>
        <!---Cat类型 需要连个 需拆分出来--->
        <div class="AdBlock Ad-Top" v-if="IsHasCat1 || IsHasCat || IsHasCat2">
            <div class="AdBlockTitle">
                {{ GetAllCat[0].NumsIndex + ". " + (isSearchResult ? $t("lbl_EMPBE_Ad_SRIsBelow") + " - " +
                    $t('Lbl_ProductCategory') : $t('Lbl_ProductCategory')) }}
            </div>
            <div class="AdBlockTitle_p">
                <span>{{ $t('lbl_EMPBE_Ad_Product_Category_P_FirstHalf') }}</span>
                <router-link :to="{ path: IsProductSelect ?  '/productInfoCenter/default' : '/companyInfoCenter/default' }" 
                custom v-slot="{ navigate }"
                >
                    <a href="javascript:void(0)" @click="navigate($event)" class="AdBlockTitle_p_CompanyInfo">
                        {{ IsProductSelect ? $t('lbl_EMPBE_ProductInfoCenter') : $t('lbl_EMPBE_CompanyInfoCenter') }}
                    </a>
                </router-link>
                <span>{{ $t('lbl_EMPBE_Ad_Product_Category_P_RemainingHalf') }}</span>
            </div>
            <div class="AdBlockTitle_Cat_Level" v-if="IsHasCat1">
                <div class="row">
                    <div class="col-8 AdBlockTitle_p_Cat_level">
                        {{ $t('lbl_EMPBE_Ad_Level1') }}
                    </div>
                </div>
                <div class="AdBlockTitle_Cat_Select"  v-for="tCat1item in GetCat1" :key="'Cat1_'+tCat1item.rid">
                    <AdSlotPreviewRow :url="getSlotPreviewUrl(tCat1item)">
                    <PublicSelect v-loading="Loading" :TagTextParm="Cat1TagTextParm" :checkNull="checkNull" v-if="RefreshChildComponents"
                        :isMandatory="true" :id="'Cat1_' + tCat1item.adDetailId" :disabled="isReadonly"
                        :SelectParm="SelectParms" :SelectType="0" :SelectData="GetCat1Data(tCat1item)"
                        :selectOptions="(tCat1item.searchId < 0 || !!tCat1item.uPError ? undefined : tCat1item.searchId)"
                        :external-error="!!tCat1item.uPError"
                        :external-error-text="IsProductSelect ? $t('lbl_EMPBE_PublicSelect_UpstreamOptionMissing_Prod') : $t('lbl_EMPBE_PublicSelect_UpstreamOptionMissing_Comp')"
                        @ChangeSelectStr="ChagneSelectStr($event, tCat1item)" @noticeMethods="noticeMethods"
                        @noticeErrorMethods="noticeErrorMethods" :IsAllowNullText="false"></PublicSelect>
                    </AdSlotPreviewRow>
                </div>
            </div>
            <div class="AdPosition Ad-Top " v-if="IsHasCat1 && GetPositions.cat1 && GetPositions.cat1.length > 0">
                <div class="AdPosition-Title">{{ $t('lbl_EMPBE_Ad_Position') }}</div>
                <span class="AdPosition-Value" v-for="(item, index) in GetPositions.cat1" :key="item+'_index_'+index">
                    #{{ item }}
                    <span v-if="index < GetPositions.cat1.length - 1">
                        /
                    </span>
                </span>
            </div>
            <div class="AdBlockTitle_Cat_Level" v-if="IsHasCat2">
                <div class="row">
                    <div class="col-8 AdBlockTitle_p_Cat_level">
                        {{ $t('lbl_EMPBE_Ad_Level2') }}
                    </div>
                </div>
                <div class="AdBlockTitle_Cat_Select" v-for="tCat2item in GetCat2" :key="'Cat2_'+tCat2item.rid">
                    <AdSlotPreviewRow :url="getSlotPreviewUrl(tCat2item)">
                    <PublicSelect v-loading="Loading" :TagTextParm="Cat2TagTextParm" :checkNull="checkNull" v-if="RefreshChildComponents"
                        :isMandatory="true" :id="'Cat2_' + tCat2item.adDetailId" :disabled="isReadonly"
                        :SelectParm="SelectParms" :SelectType="0" :SelectData="GetCat2Data(tCat2item)"
                        :selectOptions="(tCat2item.searchId < 0 || !!tCat2item.uPError ? undefined : tCat2item.searchId)"
                        :external-error="!!tCat2item.uPError"
                        :external-error-text="IsProductSelect ? $t('lbl_EMPBE_PublicSelect_UpstreamOptionMissing_Prod') : $t('lbl_EMPBE_PublicSelect_UpstreamOptionMissing_Comp')"
                        @ChangeSelectStr="ChagneSelectStr($event, tCat2item)" @noticeMethods="noticeMethods"
                        @noticeErrorMethods="noticeErrorMethods" :IsAllowNullText="false"></PublicSelect>
                    </AdSlotPreviewRow>
                </div>
            </div>
            <div class="AdPosition Ad-Top " v-if="IsHasCat2 && GetPositions.cat2 && GetPositions.cat2.length > 0">
                <div class="AdPosition-Title">{{ $t('lbl_EMPBE_Ad_Position') }}</div>
                <span class="AdPosition-Value" v-for="(item, index) in GetPositions.cat2" :key="item+'_index_'+index">
                    #{{ item }}
                    <span v-if="index < GetPositions.cat2.length - 1">
                        /
                    </span>
                </span>
            </div>
            <div class="AdBlockTitle_Cat_Level" v-if="IsHasCat">
                <div class="row">
                    <div class="col-8 AdBlockTitle_p_Cat_level">
                        {{ $t('lbl_EMPBE_Ad_Level3') }}
                    </div>
                </div>
                <div class="AdBlockTitle_Cat_Select" v-for="GetCatItem in GetCat" :key="'Cat_'+GetCatItem.rid">
                    <AdSlotPreviewRow :url="getSlotPreviewUrl(GetCatItem)">
                    <PublicSelect v-loading="Loading" :TagTextParm="Cat3TagTextParm" :checkNull="checkNull" v-if="RefreshChildComponents"
                        :isMandatory="true" :id="'Cat_' + GetCatItem.adDetailId" :disabled="isReadonly"
                        :SelectParm="SelectParms" :SelectType="0" :SelectData="GetCatData(GetCatItem)"
                        :selectOptions="(GetCatItem.searchId < 0 || !!GetCatItem.uPError ? undefined : GetCatItem.searchId)"
                        :external-error="!!GetCatItem.uPError"
                        :external-error-text="IsProductSelect ? $t('lbl_EMPBE_PublicSelect_UpstreamOptionMissing_Prod') : $t('lbl_EMPBE_PublicSelect_UpstreamOptionMissing_Comp')"
                        @ChangeSelectStr="ChagneSelectStr($event, GetCatItem)" @noticeMethods="noticeMethods"
                        @noticeErrorMethods="noticeErrorMethods" :IsAllowNullText="false"></PublicSelect>
                    </AdSlotPreviewRow>
                </div>
            </div>
            <div class="AdPosition Ad-Top " v-if="IsHasCat && GetPositions.cat && GetPositions.cat.length > 0">
                <div class="AdPosition-Title">{{ $t('lbl_EMPBE_Ad_Position') }}</div>
                <span class="AdPosition-Value" v-for="(item, index) in GetPositions.cat" :key="item+'_index_'+index">
                    #{{ item }}
                    <span v-if="index < GetPositions.cat.length - 1">
                        /
                    </span>
                </span>
            </div>
        </div>
        <div class="AdOrText Ad-Top"
            v-if="(IsHasCat1 || IsHasCat || IsHasCat2) && MoreThenIndex(GetAllCat[0].NumsIndex)">
            {{ $t('lbl_EMPBE_Ad_Or') }} </div>
        <!---CustomKeyword拆分出来--->
        <div class="AdBlock Ad-Top" v-if="IsHasCustomKeyword">
            <div class="row">
                <div class="AdBlockTitle col-12">
                    {{ (GetCustomKeywordSlots[0] && GetCustomKeywordSlots[0].cn.NumsIndex) + ". " + (isSearchResult ? $t("lbl_EMPBE_Ad_SRIsBelow") + " - " +
                        $t('lbl_EMPBE_Ad_Custom_Keyword') : $t('lbl_EMPBE_Ad_Custom_Keyword'))}}
                </div>
            </div>
            <div class="AdBlockTitle_p">
                {{ $t('lbl_EMPBE_Ad_Custom_Keyword_P') }}
            </div>
            <!-- Figma：Custom Keyword n → In Chinese / In English 各一框，均带预览按钮 -->
            <div class="AdBlockTitle_Cat_Level AdCustomKeyword-Slot" v-for="(slot, index) in GetCustomKeywordSlots" :key="'CustomKeyword_slot_'+ (slot.orderId != null ? slot.orderId : slot.cn.rid)">
                <div class="row">
                    <div class="col-8 AdBlockTitle_p_Cat_level AdCustomKeyword-SlotTitle">
                        {{ $t('lbl_EMPBE_Ad_Custom_Keyword_Item', { no: index + 1 }) }}
                    </div>
                </div>
                <div class="row" v-if="slot.cn">
                    <div class="col-8 AdBlockTitle_p_Cat_level AdCustomKeyword-LangLabel">
                        {{ $t('lbl_EMPBE_Ad_Custom_Keyword_InCN') }}
                    </div>
                </div>
                <div class="AdBlockTitle_Cat_Select" v-if="slot.cn">
                    <AdSlotPreviewRow :url="getSlotPreviewUrl(slot.cn)">
                    <PublicInput :InputTextParm="CustomKeywordTagTextParm" :checkNull="checkNull" :isMandatory="true" v-if="RefreshChildComponents"
                        :id="'CustomKeyword_CN_' + slot.cn.adDetailId + '_' + (index + 1)" :disabled="isReadonly"
                        CharLimit="CheckCustomKeywordCn"
                        :CheckErrorText="GetCustomkeywrodErrorsVals(slot.cn.rid)"
                        :loadingStrus="GetCustomkeywrodLoadVals(slot.cn.rid)"
                        :InputStr="customKeywordDisplayText(slot.cn)"
                        @ChangeModelStr="ChangeCustomKeyWordByInput($event, slot.cn)"
                        @noticeMethods="noticeMethodsByCustomKeyword(slot.cn.rid)"
                        @noticeErrorMethods="noticeErrorMethods">
                    </PublicInput>
                    </AdSlotPreviewRow>
                    <AdSearchItemApprovalResults
                      :search-item="slot.cn"
                      :result-key-prefix="`kw_${slot.cn.rid}`"
                    />
                </div>
                <div class="row" v-if="slot.en">
                    <div class="col-8 AdBlockTitle_p_Cat_level AdCustomKeyword-LangLabel">
                        {{ $t('lbl_EMPBE_Ad_Custom_Keyword_InEN') }}
                    </div>
                </div>
                <div class="AdBlockTitle_Cat_Select" v-if="slot.en">
                    <AdSlotPreviewRow :url="getSlotPreviewUrl(slot.en)">
                    <PublicInput :InputTextParm="CustomKeywordEnTagTextParm" :checkNull="checkNull" :isMandatory="true" v-if="RefreshChildComponents"
                        :id="'CustomKeyword_EN_' + slot.en.adDetailId + '_' + (index + 1)" :disabled="isReadonly"
                        CharLimit="CheckCustomKeywordEn"
                        :CheckErrorText="GetCustomkeywrodErrorsVals(slot.en.rid)"
                        :loadingStrus="GetCustomkeywrodLoadVals(slot.en.rid)"
                        :InputStr="customKeywordDisplayText(slot.en)"
                        @ChangeModelStr="ChangeCustomKeyWordByInput($event, slot.en)"
                        @noticeMethods="noticeMethodsByCustomKeyword(slot.en.rid)"
                        @noticeErrorMethods="noticeErrorMethods">
                    </PublicInput>
                    </AdSlotPreviewRow>
                    <AdSearchItemApprovalResults
                      :search-item="slot.en"
                      :result-key-prefix="`kw_${slot.en.rid}`"
                    />
                </div>
            </div>
            <div class="AdPosition Ad-Top " v-if="GetPositions.customkeyword && GetPositions.customkeyword.length > 0">
                <div class="AdPosition-Title">{{ $t('lbl_EMPBE_Ad_Position') }}</div>
                <span class="AdPosition-Value" v-for="(item, index) in GetPositions.customkeyword" :key="item+'_index_'+index">
                    #{{ item }}
                    <span v-if="index < GetPositions.customkeyword.length - 1">
                        /
                    </span>
                </span>
            </div>
        </div>
        <div class="AdOrText Ad-Top" v-if="IsHasCustomKeyword && GetCustomKeywordSlots[0] && MoreThenIndex(GetCustomKeywordSlots[0].cn.NumsIndex)">
            {{ $t('lbl_EMPBE_Ad_Or') }} </div>
        <div v-for="(item, index) in data" :key="item.rid">
            <div class=" AdBlock Ad-Top " v-if="item.searchType.toLowerCase() == 'app'">
                <div class="row">
                    <div class="AdBlockTitle col-12">
                        {{
                            item.NumsIndex + ". " +
                            (
                                isHotApp ? $t("lbl_EMPBE_HotAppCat")
                                    : isSearchResult ? $t("lbl_EMPBE_Ad_SRIsBelow") + " - " + $t('Lbl_Application')
                                        : $t('Lbl_Application')
                            )

                        }}
                    </div>
                </div>
                <div class="AdBlockTitle_p">
                    <span>{{ $t('lbl_EMPBE_Ad_Product_APP_P_FirstHalf') }}</span>
                    <router-link :to="{ path: IsProductSelect ?  '/productInfoCenter/default' : '/companyInfoCenter/default' }" 
                    custom v-slot="{ navigate }"
                    >
                        <a href="javascript:void(0)" @click="navigate($event)" class="AdBlockTitle_p_CompanyInfo">
                            {{ IsProductSelect ? $t('lbl_EMPBE_ProductInfoCenter') : $t('lbl_EMPBE_CompanyInfoCenter') }}
                        </a>
                    </router-link>
                    <span v-if="isHotApp">{{ $t('lbl_EMPBE_Ad_Product_APP_P_RemainingHalf') }}</span>
                </div>
                <div class="AdBlockTitle_Cat_Select">
                    <AdSlotPreviewRow :url="getSlotPreviewUrl(item)">
                    <PublicSelect v-loading="Loading" :TagTextParm="AppTagTextParm" :checkNull="checkNull" v-if="RefreshChildComponents"
                        :isMandatory="true" :id="'App_' + adDetailId" :disabled="isReadonly" :SelectParm="SelectParms"
                        :SelectType="0" :SelectData="GetAppsData(item)"
                        :selectOptions="(item.searchId < 0 || !!item.uPError ? undefined : item.searchId)"
                        :external-error="!!item.uPError"
                        :external-error-text="IsProductSelect ? $t('lbl_EMPBE_PublicSelect_UpstreamOptionMissing_Prod') : $t('lbl_EMPBE_PublicSelect_UpstreamOptionMissing_Comp')"
                        @ChangeSelectStr="ChagneSelectStr($event, item)" @noticeMethods="noticeMethods"
                        @noticeErrorMethods="noticeErrorMethods" :IsAllowNullText="false"></PublicSelect>
                    </AdSlotPreviewRow>
                </div>
                <div class="AdPosition Ad-Top " v-if="GetPositions.app && GetPositions.app.length > 0">
                    <div class="AdPosition-Title">{{ $t('lbl_EMPBE_Ad_Position') }}</div>
                    <span class="AdPosition-Value" v-for="(item, index) in GetPositions.app" :key="item+'_index_'+index">
                        #{{ item }}
                        <span v-if="index < GetPositions.app.length - 1">
                            /
                        </span>
                    </span>
                </div>
            </div>

            <div class="AdBlock Ad-Top " v-if="item.searchType.toLowerCase() == 'keyword' && IsSelectableKeyword(item)">
                <div class="row">
                    <div class="AdBlockTitle col-10">
                        {{
                            item.NumsIndex + ". " +
                            (
                                isSearchResult ? $t("lbl_EMPBE_Ad_SRIsBelow") + " - " + $t('lbl_EMPBE_Ad_Tag') :
                                    $t('lbl_EMPBE_Ad_Tag')
                            )
                        }}
                    </div>
                </div>
                <div class="AdBlockTitle_p" v-if="IsProductSelect">
                    <span>{{ $t('lbl_EMPBE_Ad_Product_Category_P_FirstHalf') }}</span>
                    <router-link :to="{ path: '/productInfoCenter/default'}" 
                    custom v-slot="{ navigate }"
                    >
                    <a href="javascript:void(0)" @click="navigate($event)" class="AdBlockTitle_p_CompanyInfo">
                        {{ $t('lbl_EMPBE_ProductInfoCenter') }}
                    </a>
                    </router-link>
                    <span>{{ $t('lbl_EMPBE_Ad_Product_Category_P_RemainingHalf') }}</span>
                </div>
                <div class="AdBlockTitle_Cat_Level">
                    <!--Tag标签搜索框-->
                    <div class="AdBlockTitle_Cat_Select">
                        <AdSlotPreviewRow :url="getSlotPreviewUrl(item)">
                        <PublicSelect v-loading="Loading" :TagTextParm="KeywordTagTextParm" :checkNull="checkNull" v-if="RefreshChildComponents"
                            :isMandatory="false" :id="'Keyword_' + adDetailId" :disabled="isReadonly"
                            :SelectParm="SelectParms" :SelectType="0"
                            :SelectData="GetKeywordData(item)"  
                            :selectOptions="(item.searchId < 0 || !!item.uPError ? undefined : item.searchId)"
                            :external-error="!!item.uPError"
                            :external-error-text="IsProductSelect ? $t('lbl_EMPBE_PublicSelect_UpstreamOptionMissing_Prod') : $t('lbl_EMPBE_PublicSelect_UpstreamOptionMissing_Comp')"
                            @ChangeSelectStr="ChagneSelectStr($event, item)" @noticeMethods="noticeMethods"
                            @noticeErrorMethods="noticeErrorMethods" :IsAllowNullText="false"></PublicSelect>
                        </AdSlotPreviewRow>
                    </div>
                </div>
                <div class="AdPosition Ad-Top " v-if="GetPositions.keyword && GetPositions.keyword.length > 0">
                    <div class="AdPosition-Title">{{ $t('lbl_EMPBE_Ad_Position') }}</div>
                    <span class="AdPosition-Value" v-for="(item, index) in GetPositions.keyword" :key="item+'_index_'+index">
                        #{{ item }}
                        <span v-if="index < GetPositions.keyword.length - 1">
                            /
                        </span>
                    </span>
                </div>
            </div>

            <div class="AdOrText Ad-Top"
                v-if="(item.searchType.toLowerCase() == 'app' || item.searchType.toLowerCase() == 'keyword' && IsSelectableKeyword(item)) && MoreThenIndex(item.NumsIndex)">
                {{ $t('lbl_EMPBE_Ad_Or') }} </div>
        </div>
    </div>
</template>
<script>


import { getAncestorPath } from '@/_helpers/treeUtils';
import { adService } from "../../_services";
import { buildDisplayPreviewUrlForSearchItem } from './adDisplayConfig';
import AdSearchItemApprovalResults from './AdSearchItemApprovalResults.vue';
import AdSlotPreviewRow from './AdSlotPreviewRow.vue';
export default {
    components: {
        AdSearchItemApprovalResults,
        AdSlotPreviewRow,
    },
    props: [
        "data",
        "isHotApp",
        'hideTitle',
        "AdsDisplayOption",
        "AdsData",
        "isPriority",
        "adDetailId",
        "isReadonly",
        "checkNull",
        "isSearchResult",
        'selectProd',
        'AdOptionsData',
        'prodCats',
        'HotAppIds',
        "IsProductSelect",
        "displayPreviewUrl",
        "refreshToken",
    ],
    data() {
        return {
            RefreshChildComponents:true,
            CreatedView:true,
            Loading: false,
            IsUAT: true,//process.env.VUE_APP_EMP_IsUat=="true"?true:false,
            //For Confirmation modal
            CurAdsSearchType: "",
            CurrentRids: "",
            CurAdsSearchByObj: "",
            CustomKeywordsVaildChecksData: [],
            CustomKeywordsVaildRulesMsg: [],
            SelectVals: this.AdOptionsData ?? [],
            SelectParms: {
                key: "searchId",
                label: "text",
                value: "searchId",
                disabled: "disabled"
            },
            OriginData: [],
            AllowSelect: [
                "cat",
                "cat1",
                "cat2",
                "keyword",
                "customkeyword",
                "app"
            ],
            Cat1TagTextParm:
            {
                placeholder: this.$t("lbl_EMPBE_Ad_Product_Category_Placeother1"),
                errorText: this.$t("lbl_EMPBE_Companted_Tags_Requeid"),
                NoTopErrorText: this.$t("lbl_EMPBE_Ad_Select_ErrorText")
            },
            Cat2TagTextParm:
            {
                placeholder: this.$t("lbl_EMPBE_Ad_Product_Category_Placeother2"),
                errorText: this.$t("lbl_EMPBE_Companted_Tags_Requeid"),
                NoTopErrorText: this.$t("lbl_EMPBE_Ad_Select_ErrorText")
            },
            Cat3TagTextParm:
            {
                placeholder: this.$t("lbl_EMPBE_Ad_Product_Category_Placeother3"),
                errorText: this.$t("lbl_EMPBE_Companted_Tags_Requeid"),
                NoTopErrorText: this.$t("lbl_EMPBE_Ad_Select_ErrorText")
            },
            AppTagTextParm:
            {
                placeholder: this.$t("lbl_EMPBE_Ad_Application_Placeother"),
                errorText: this.$t("lbl_EMPBE_Companted_Tags_Requeid"),
                NoTopErrorText: this.$t("lbl_EMPBE_Ad_Select_ErrorText")
            },
            KeywordTagTextParm:
            {
                placeholder: this.$t("lbl_EMPBE_Ad_Tag_Placeother"),
                errorText: this.$t("lbl_EMPBE_Companted_Tags_Requeid"),
                NoTopErrorText: this.$t("lbl_EMPBE_Ad_Select_ErrorText")
            },
            CustomKeywordTagTextParm:
            {
                placeholder: this.$t("lbl_EMPBE_Ad_Custom_Keyword_Placeother"),
                errorText: this.$t("lbl_EMPBE_Companted_Tags_Requeid"),
            },
            CustomKeywordEnTagTextParm:
            {
                placeholder: this.$t("lbl_EMPBE_Ad_Custom_Keyword_EN_Placeother"),
                errorText: this.$t("lbl_EMPBE_Companted_Tags_Requeid"),
            },
            customKeywordInput:
                [

                ]
        }
    },
    mounted() {
        this.AddDataIndex();
        this.GetCustomKeywordInputMethods();
        this.OriginData = JSON.parse(JSON.stringify(this.data));
        // Vue2 响应式兜底：确保 uPError 字段存在（后端校验失败时用于外部红框提示）
        (this.data || []).forEach(item => {
            if (item && typeof item === 'object' && item.uPError === undefined) {
                this.$set(item, 'uPError', false);
            }
        });
        setTimeout(() => {
            this.CreatedView = false;
        }, 3000);
        // if (this.adDetailId) {
        //     this.GetSearchAdCriteriaQuotaMethods();
        // }
    },
    watch: {
        AdOptionsData() {
            this.SelectVals = this.AdOptionsData ?? [];
        },
        // 上游数据过期后父组件递增 refreshToken 并重新 GetSearchAdOptions
        refreshToken() {
            this.SelectVals = this.AdOptionsData ?? [];
            this.RefreshChildComponents = false;
            this.$nextTick(() => {
                this.RefreshChildComponents = true;
            });
        },
        selectProd: {
            handler(newVal, oldVal) {
                if (!this.CreatedView && this.selectProd?.IsSelectProd) {
                    this.RefreshChildComponents = false;
                    this.ChangeLevelInput();
                    this.$nextTick(() => {
                        this.RefreshChildComponents = true;
                    });
                }
            },
            deep: true,
        },
        checkNull() {
            if (this.checkNull) {
                var res = this.SelectVals.filter(item => item.disabled).map(item => {
                    return {
                        ErrorAdDetailId: this.adDetailId,
                        text: item.text
                    }
                })
                this.$emit("ErrorSelect", res)
            }
        },
        //因为存在addetailId后刷新的情况
        // adDetailId() {
        //     if (this.adDetailId) {
        //         this.GetSearchAdCriteriaQuotaMethods();
        //     }
        // },
        data: {

            handler(val) {

                this.AddDataIndex();
                if (this.customKeywordInput.length < 1)
                    this.GetCustomKeywordInputMethods();

                // Vue2 响应式兜底：确保 uPError 字段存在（避免后续动态添加不触发渲染）
                (val || []).forEach(item => {
                    if (item && typeof item === 'object' && item.uPError === undefined) {
                        this.$set(item, 'uPError', false);
                    }
                });
            },
            deep: true
        }
    },
    computed: {
        GetProdUpCats(){
            var upReslut = [];
            var catIds = this.selectProd?.catIds?.split(',') ?? [];
            upReslut = catIds.flatMap(id => {
            var result2 = getAncestorPath(this.prodCats, id);
            return result2.length > 0 ? result2 : [];
          }) ?? []
          return upReslut;
        },
        GetProdUpApps(){
            return this.selectProd?.industryIds?.split(',') ?? []
        },
        GetProdUpkeywordIds(){
            return this.selectProd?.keywordIds?.split(',') ?? []
        },
        GetTheme() {
            return this.data.filter(x => x.searchType.toLowerCase() == "keyword" && !this.IsSelectableKeyword(x));
        },

        IsHasCat() {
            var lengths = this.data.filter(x => x.searchType.toLowerCase() == 'cat').length;
            return lengths > 0;
        },
        IsHasCat1() {
            var lengths = this.data.filter(x => x.searchType.toLowerCase() == 'cat1').length;
            return lengths > 0;
        },
        IsHasCat2() {
            var lengths = this.data.filter(x => x.searchType.toLowerCase() == 'cat2').length;
            return lengths > 0;
        },
        GetAllCat() {
            return this.data.filter(x => x.searchType.toLowerCase() == "cat2" || x.searchType.toLowerCase() == "cat" || x.searchType.toLowerCase() == "cat1")
        },
        IsHasCustomKeyword() {
            return this.GetCustomKeywordSlots.length > 0;
        },
        GetCustomKeyword() {
            // 槽位主行（简中 936）；英文 1252 经 GetCustomKeywordSlots.en 绑定
            return this.GetCustomKeywordSlots.map((s) => s.cn);
        },
        GetCustomKeywordSlots() {
            const all = (this.data || []).filter(
                (x) => x.searchType && x.searchType.toLowerCase() === "customkeyword"
            );
            const resolveLangId = (item) => {
                const raw = item.langId != null ? item.langId : item.LangId;
                if (raw == null || raw === "") return null;
                const n = Number(raw);
                return Number.isFinite(n) ? n : null;
            };
            const resolveOrderId = (item) => {
                const raw = item.orderId != null ? item.orderId : item.OrderId;
                if (raw == null || raw === "") return null;
                const n = Number(raw);
                return Number.isFinite(n) ? n : null;
            };
            const pickCnEn = (group) => {
                const sorted = group.slice().sort((a, b) => Number(a.rid) - Number(b.rid));
                let cn =
                    sorted.find((x) => resolveLangId(x) === 936) ||
                    sorted.find((x) => resolveLangId(x) !== 1252) ||
                    null;
                let en = sorted.find((x) => resolveLangId(x) === 1252) || null;
                // 仅当同组恰好两行且都未标 LangId：按 RID 小=中文、大=英文（避免覆盖已标 936 的行）
                const bothUnlabeled =
                    sorted.length === 2 &&
                    sorted.every((x) => resolveLangId(x) == null);
                if (!en && bothUnlabeled) {
                    cn = sorted[0];
                    en = sorted[1];
                }
                if (en && cn && Number(en.rid) === Number(cn.rid)) en = null;
                return { cn, en };
            };

            const usedRids = new Set();
            const slots = [];

            // 1) 有 OrderId：按槽位成组（Figma：Custom Keyword n = 中+英）
            const orderKeys = [
                ...new Set(
                    all
                        .map((x) => resolveOrderId(x))
                        .filter((id) => id != null)
                ),
            ].sort((a, b) => a - b);

            orderKeys.forEach((orderId) => {
                const group = all.filter((x) => resolveOrderId(x) === orderId);
                const { cn, en } = pickCnEn(group);
                if (!cn) return;
                usedRids.add(cn.rid);
                if (en) usedRids.add(en.rid);
                slots.push({ cn, en, orderId });
            });

            // 2) 无 OrderId（或漏网）：勿丢行；英文优先 ReferRID，否则同广告按 RID 顺序挂 LangId=1252
            const remaining = all.filter((x) => !usedRids.has(x.rid));
            const cnRows = remaining
                .filter((x) => resolveLangId(x) !== 1252)
                .slice()
                .sort((a, b) => Number(a.rid) - Number(b.rid));
            const enRows = remaining
                .filter((x) => resolveLangId(x) === 1252)
                .slice()
                .sort((a, b) => Number(a.rid) - Number(b.rid));
            const usedEn = new Set();
            cnRows.forEach((cn) => {
                let en =
                    enRows.find((e) => {
                        if (usedEn.has(e.rid)) return false;
                        if (Number(e.adDetailId) !== Number(cn.adDetailId)) return false;
                        const rr = Number(e.referRID ?? e.ReferRID ?? e.referRid ?? 0);
                        return rr === Number(cn.rid);
                    }) || null;
                if (!en) {
                    en =
                        enRows.find(
                            (e) =>
                                !usedEn.has(e.rid) &&
                                Number(e.adDetailId) === Number(cn.adDetailId)
                        ) || null;
                }
                if (en) usedEn.add(en.rid);
                slots.push({ cn, en, orderId: slots.length + 1 });
            });

            return slots;
        },
        GetCat2() {
            return this.data.filter(x => x.searchType.toLowerCase() == "cat2");
        },
        GetCat() {
            return this.data.filter(x => x.searchType.toLowerCase() == "cat");
        },
        GetCat1() {
            return this.data.filter(x => x.searchType.toLowerCase() == "cat1");
        },
        GetApp() {
            return this.data.filter(x => x.searchType.toLowerCase() == "app");
        },
        GetKeyWord() {
            return this.data.filter(x => x.searchType.toLowerCase() == "keyword" && (parseInt(x.searchId) === -1 || (parseInt(x.searchId) > 100 && parseInt(x.searchId) < 200)));
        },
        GetPositions() {
            const keyMapping = {
                category1_position: "cat1",
                category2_position: "cat2",
                category_position: "cat",
                application_position: "app",
                keyword_position: "keyword",
                customkeyword_position: "customkeyword",
            };

            const positions = this.data.filter(x => x.searchType.toLowerCase().endsWith('position'));
            const res = positions.reduce((accu, curr) => {
                const key = keyMapping[curr.searchType.toLowerCase()];
                if (!accu[key]) {
                    return {
                        ...accu,
                        [key]: [curr.searchId],
                    }
                }

                return {
                    ...accu,
                    [key]: [...accu[key], curr.searchId].sort((a, b) => a - b),
                };
            }, {});
            return res;
        },
        user() {
            return this.$store.state.authentication.user;
        },
        companyid() {
            return this.supplierId === null ||
                this.supplierId === undefined ||
                this.supplierId === ""
                ? this.user.empCompanyId
                : this.supplierId;
        },
        langid() {
            return localStorage.getItem("currentLangId");
        }
    },
    methods: {
        getSlotPreviewUrl(searchItem) {
            return buildDisplayPreviewUrlForSearchItem(this.displayPreviewUrl, searchItem, {
                keywordOptions: this.SelectVals,
                langId: this.langid,
            });
        },
        ChangeLevelInput(){
            if(this.GetCat1.length>0)
            {
                var Cat_searchId = this.SelectVals.find(x => x.searchType.toLowerCase() == 'cat1' && this.GetProdUpCats.includes(x.searchId))?.searchId ?? '-1';
                
                this.GetCat1.forEach(item=>{
                    this.ChagneSelectStr({searchId:Cat_searchId},item)
                })
            }else if(this.GetCat2.length>0)
            {
                 var Cat_searchId2 = this.SelectVals.find(x => x.searchType.toLowerCase() == 'cat2' && this.GetProdUpCats.includes(x.searchId))?.searchId ?? '-1';
                
                this.GetCat2.forEach(item=>{
                    this.ChagneSelectStr({searchId:Cat_searchId2},item)
                })
            }else if(this.GetCat.length>0)
            {
                var Cat_searchId3 = this.SelectVals.find(x => x.searchType.toLowerCase() == 'cat' && this.GetProdUpCats.includes(x.searchId))?.searchId ?? '-1';
                
                this.GetCat.forEach(item=>{
                    this.ChagneSelectStr({searchId:Cat_searchId3},item)
                })
            }
           
            if(this.GetApp.length>0)
            {
                var App_searchId = this.SelectVals.filter(x => this.HotAppIds.includes(x.searchId)).find(x => x.searchType.toLowerCase() == 'app' && this.GetProdUpApps.includes(x.searchId))?.searchId ?? '-1';
                
                this.GetApp.forEach(item=>{
                    this.ChagneSelectStr({searchId:App_searchId},item)
                })
            }
            if(this.GetKeyWord.length>0)
            {
                 var KeyWord_searchId = this.SelectVals.find(x => x.searchType.toLowerCase() == 'keyword' && this.GetProdUpkeywordIds.includes(x.searchId))?.searchId ?? '-1';
                this.GetKeyWord.forEach(item=>{
                    this.ChagneSelectStr({searchId:KeyWord_searchId},item)
                })
            }
        },
        GetCustomKeywordInputMethods() {
            if (this.data) {
                this.customKeywordInput = this.data.filter(item => item.searchType.toLowerCase() == 'customkeyword').map(item => {
                    return {
                        rid: item.rid,
                        errorText: "",
                        loadingStrus: false
                    }
                })

            }
        },
        GetCustomkeywrodErrorsVals(rid) {
            var obj = this.customKeywordInput.find(item => item.rid == rid);
            return obj ? obj.errorText : "";
        },
        GetCustomkeywrodLoadVals(rid) {
            var obj = this.customKeywordInput.find(item => item.rid == rid);

            return obj ? obj.loadingStrus : false;
        },
        MoreThenIndex(nums) {
            return this.data.filter(item => item.NumsIndex > nums && this.AllowSelect.includes(item.searchType.toLowerCase())).length > 0;
        },
        AddDataIndex() {
            if (this.data) {
                var index = 0;
                //优先处理 theme 和 cat customkeyword
                if (this.GetTheme.length > 0) {
                    index++
                    this.GetTheme
                        .forEach(item => {
                            this.$set(item, 'NumsIndex', index);
                        });
                }

                if (this.IsHasCat || this.IsHasCat1 || this.IsHasCat2) {
                    index++;
                    this.GetAllCat
                        .forEach(item => {
                            this.$set(item, 'NumsIndex', index);
                        })
                }
                if (this.IsHasCustomKeyword) {
                    index++;
                    this.GetCustomKeywordSlots.forEach((slot) => {
                        this.$set(slot.cn, 'NumsIndex', index);
                        // 仅在缺失时补 LangId，避免覆盖已有语言标记
                        if (slot.cn.langId == null && slot.cn.LangId == null) {
                            this.$set(slot.cn, 'langId', 936);
                        }
                        if (slot.en) {
                            this.$set(slot.en, 'NumsIndex', index);
                            if (slot.en.langId == null && slot.en.LangId == null) {
                                this.$set(slot.en, 'langId', 1252);
                            }
                        }
                    });
                }

                this.data
                    .forEach(item => {
                        if (item.searchType.toLowerCase() == 'app' || (item.searchType.toLowerCase() == 'keyword' && this.IsSelectableKeyword(item))) {
                            index++;
                            this.$set(item, 'NumsIndex', index);
                        }
                    })
            }
        },
        GetKeywordData(item) {
            var res = this.SelectVals.filter(x => x.searchType.toLowerCase() == 'keyword');
            if(this.IsProductSelect)
            {
                if(!this.selectProd?.keywordIds)
                {
                    res=[];
                }

                 res = res.filter(x=>this.GetProdUpkeywordIds.includes(x.searchId))
            }
            this.CheckIsHasOriginId(item,res);
            return res;
        },
        GetAppsData(item) {
            var res = this.SelectVals.filter(x => x.searchType.toLowerCase() == 'app');
            if(this.isHotApp)
                res = res.filter(x => this.HotAppIds.includes(x.searchId))
            if(this.IsProductSelect)
            {
                if(!this.selectProd?.industryIds)
                {
                    res=[];
                }


                 res = res.filter(x=>this.GetProdUpApps.includes(x.searchId))
            }
            this.CheckIsHasOriginId(item,res);
            return res;
        },
        GetCat1Data(item) {
            var res = this.SelectVals.filter(x => x.searchType.toLowerCase() == 'cat1');
            if(this.IsProductSelect)
            {
                if(!this.selectProd?.catIds)
                {
                    res=[];
                }

                 res = res.filter(x=>this.GetProdUpCats.includes(x.searchId))
            }

            this.CheckIsHasOriginId(item,res);
            return res;
        },
        GetCat2Data(item) {
            var res = this.SelectVals.filter(x => x.searchType.toLowerCase() == 'cat2');
            if(this.GetCat1.length > 0)
                res = res.filter(x => this.GetCat1.map(item=>item.searchId).includes(x.parentId));

            if(this.IsProductSelect)
            {
                if(!this.selectProd?.catIds)
                {
                    res=[];
                }

                 res = res.filter(x=>this.GetProdUpCats.includes(x.searchId))
            }

            this.CheckIsHasOriginId(item,res);
            return res;
        },
        GetCatData(item) {
            var res = this.SelectVals.filter(x => x.searchType.toLowerCase() == 'cat');
            if(this.GetCat2.length > 0)
                res = res.filter(x => this.GetCat2.map(item=>item.updateValue??item.searchId).includes(x.parentId));
            
            if(this.IsProductSelect)
            {
                if(!this.selectProd?.catIds)
                {
                    res=[];
                }


                 res = res.filter(x=>this.GetProdUpCats.includes(x.searchId))
            }
            
            this.CheckIsHasOriginId(item,res);
            return res;
        },
        CheckIsHasOriginId(item,data) {
            if(!item.uPError){
                var IsHasId = data.find(x => x.searchId == item.searchId && x.searchType.toLowerCase() == item.searchType.toLowerCase());
                if (!IsHasId && item.searchId >= 0 && item.text) {
                    data.push({
                        searchType: item.searchType.toLowerCase(),
                        searchId: item.searchId,
                        text: item.text,
                        parentId:item.parentId
                    })
                }
            }
        },
        IsSelectableKeyword(item) {
            return parseInt(item.searchId) === -1 || (parseInt(item.searchId) > 100 && parseInt(item.searchId) < 200); // -1 means waiting for selection
        },
        ReturnTitleName(name) {

        },
        CanUpdateType(type) {
            return this.AllowSelect.includes(type);
        },
        noticeMethods() {
            this.$emit("noAllowSubmit")
        },
        noticeMethodsByCustomKeyword(rid) {
            this.customKeywordInput.find(item => item.rid == rid).errorText = "";
            this.$emit("noAllowSubmit")
        },
        noticeErrorMethods(strus) {
            this.$emit("noticeErrorSubmit", strus)
        },
        ChagneSelectStr(event, item) {
            console.log("选项结果",event,item)
            this.$set(item, "updateValue", event.searchId)
            this.$set(item, "searchId", event.searchId)
            this.$set(item, "IsUpdate", true)
            // 用户重新选择后，立即清除“上游无该选项”的错误提示（不必等下一次后端校验）
            if (item && item.uPError) {
                this.$set(item, "uPError", false);
            }
            if(item.searchType.toLowerCase()=='cat1'){
                var Level2Vals=this.SelectVals.filter(x=>this.GetProdUpCats.includes(x.searchId) || !this.IsProductSelect).find(x=>x.searchType.toLowerCase()=='cat2' && x.parentId == event.searchId)?.searchId ?? '-1'
  
                this.GetCat2.forEach(a=>{
                        this.$set(a, "updateValue",Level2Vals)
                        this.$set(a, "searchId",Level2Vals)
                        this.$set(a, "IsUpdate", true)
                        if (a && a.uPError) this.$set(a, "uPError", false);
                })
    
                    var Level3Vals=this.SelectVals.filter(x=>this.GetProdUpCats.includes(x.searchId) || !this.IsProductSelect).find(x=>x.searchType.toLowerCase()=='cat' && x.parentId == Level2Vals)?.searchId ?? '-1'
                  
                    this.GetCat.forEach(a=>{
                        this.$set(a, "updateValue",Level3Vals)
                        this.$set(a, "searchId",Level3Vals)
                        this.$set(a, "IsUpdate", true)
                        if (a && a.uPError) this.$set(a, "uPError", false);
                    })
                
            }else if(item.searchType.toLowerCase()=='cat2'){
                    var Level3Vals=this.SelectVals.filter(x=>this.GetProdUpCats.includes(x.searchId)  || !this.IsProductSelect).find(x=>x.searchType.toLowerCase()=='cat' && x.parentId == event.searchId)?.searchId ?? '-1'
                
                    this.GetCat.forEach(a=>{
                        this.$set(a, "updateValue",Level3Vals)
                        this.$set(a, "searchId",Level3Vals)
                        this.$set(a, "IsUpdate", true)
                        if (a && a.uPError) this.$set(a, "uPError", false);
                    })
            }
        },
        customKeywordDisplayText(item) {
            if (!item) return '';
            return item.updateValue != null ? String(item.updateValue) : String(item.text || '');
        },
        // 需求：中文可含中/英/数字、禁标点；英文仅英/数字、禁标点
        resolveCustomKeywordLangId(item) {
            const raw = item && (item.langId != null ? item.langId : item.LangId);
            if (raw == null || raw === "") return 936;
            const n = Number(raw);
            return Number.isFinite(n) ? n : 936;
        },
        getCustomKeywordCharsetError(str, item) {
            if (!str) return "";
            const langId = this.resolveCustomKeywordLangId(item);
            if (langId === 1252) {
                // 英文：字母/数字/空格（可含空格）；禁中文与标点
                if (!/^[A-Za-z0-9 ]+$/.test(str)) {
                    return this.$t("lbl_EMPBE_Ad_CustomKeyword_Charset_EN");
                }
            } else if (!/^[\u4e00-\u9fffA-Za-z0-9]+$/.test(str)) {
                return this.$t("lbl_EMPBE_Ad_CustomKeyword_Charset_CN");
            }
            return "";
        },
        ChangeCustomKeyWordByInput(str, item) {
            const langId = this.resolveCustomKeywordLangId(item);
            let cleaned = str == null ? "" : String(str);
            if (langId === 1252) {
                cleaned = cleaned.replace(/[^A-Za-z0-9 ]/g, "");
            } else {
                cleaned = cleaned.replace(/[^\u4e00-\u9fffA-Za-z0-9]/g, "");
            }
            this.$set(item, "updateValue", cleaned)
            this.$set(item, "text", cleaned)
            this.$set(item, "IsUpdate", true)
            if (cleaned.length > 0) {
                this.ValidateAdCustomKeywordMethodsByInput(cleaned, item)
            } else {
                const obj = this.customKeywordInput.find((f) => f.rid == item.rid);
                if (obj) obj.errorText = "";
            }
        },
        ChangeCustomKeyWord(str, item) {
            this.$set(item, "updateValue", str)
            this.$set(item, "IsUpdate", true)
            var SplitStr = str.split(',');
            this.CustomKeywordsVaildRulesMsg = [];
            this.CustomKeywordsVaildChecksData = [];
            SplitStr.forEach(element => {
                if (element != this.GetCustomKeywordOrigin(item) && element)
                    this.ValidateAdCustomKeywordMethods(element)
            });
        },
        GetCustomKeywordOrigin(item) {
            return this.OriginData.filter(originitem => originitem.searchId == item.searchId && originitem.searchType.toLowerCase() == "customkeyword").map(originitem => originitem.text)[0];
        },
        // GetSearchAdCriteriaQuotaMethods() {
        //     this.Loading = true;
        //     var parms = { companyId: this.companyid, adDetailId: this.adDetailId, langId: this.langid }
        //     adService.GetSearchAdCriteriaQuota(parms).then(res => {
        //         if (res.statusCode == 200) {
        //             this.SelectVals = res.data.reduce((acc, curr) => {
        //                 const existingItem = acc.find(item => item.searchId === curr.searchId && item.searchType.toLowerCase() === curr.searchType.toLowerCase());
        //                 if (existingItem) {
        //                     if (curr.value < existingItem.value) {
        //                         const index = acc.findIndex(item => item.searchId === curr.searchId && item.searchType.toLowerCase() === curr.searchType.toLowerCase());
        //                         curr.disabled = curr.quota <= 0;
        //                         acc.splice(index, 1, curr);
        //                     }
        //                 } else {
        //                     curr.disabled = curr.quota <= 0;
        //                     acc.push(curr);
        //                 }

        //                 return acc;
        //             }, []);
        //             this.Loading = false;
        //         }
        //     });
        // },
        ValidateAdCustomKeywordMethods(customKeyword) {
            var parms = { companyId: this.companyid, adDetailId: this.adDetailId, customKeyword: customKeyword, langId: this.langid }
            adService.ValidateAdCustomKeyword(parms).then(res => {
                if (res.statusCode == 200) {
                    var ReturnData = res.data;
                    if (!ReturnData.isValid) {
                        var ChecksData = { type: this.CustomKeywordsVaildChecksData.length + 1, text: customKeyword }
                        var RulesMsg = { type: this.CustomKeywordsVaildRulesMsg.length + 1, message: "" }
                        switch (ReturnData.invalidType) {
                            case "Restricted":
                                var HasType = ReturnData.restrictedKeywords.map(item => item.type);
                                RulesMsg.message = this.$t("lbl_EMPBE_Ad_CustomKeyword_ErrorText", { text: customKeyword });
                                break;
                            case "Quota":
                                // 广告侧不再校验名额，忽略 Quota
                                return;
                        }
                        // //检验是否存在与平台不符内容
                        // var IsHasCompany = ReturnData.restrictedKeywords.find(x => x.invalidType=='Company');

                        // if(IsHasCompany)
                        //     RulesMsg.message= customKeyword+", cannot be the same as the current company short name on the platform.";

                        this.CustomKeywordsVaildRulesMsg.push(RulesMsg);
                        this.CustomKeywordsVaildChecksData.push(ChecksData);
                    }
                }
            })
        },
        ValidateAdCustomKeywordMethodsByInput(customKeyword, item) {
            var obj = this.customKeywordInput.find(f => f.rid == item.rid);
            if (!obj) return;
            const charsetErr = this.getCustomKeywordCharsetError(customKeyword, item);
            if (charsetErr) {
                obj.loadingStrus = false;
                obj.errorText = charsetErr;
                return;
            }
            var parms = { companyId: this.companyid, adDetailId: this.adDetailId, customKeyword: customKeyword, langId: this.langid }
            obj.loadingStrus = true;
            setTimeout(() => {
                adService.ValidateAdCustomKeyword(parms).then(res => {
                    if (res.statusCode == 200) {
                        var ReturnData = res.data;
                        var ErrorStr = "";
                        if (!ReturnData.isValid) {
                            switch (ReturnData.invalidType) {
                                case "Restricted":
                                    ErrorStr = this.$t("lbl_EMPBE_Ad_CustomKeyword_ErrorText", { text: customKeyword });
                                    break;
                                case "Quota":
                                    // 广告侧不再校验名额，忽略 Quota
                                    break;
                            }
                        }

                        obj.loadingStrus = false;
                        obj.errorText = ErrorStr;

                    }
                })
            }, 2000);

        },
    },
}
</script>
<style>
.adDisplayDot {
    font-size: 4px !important;
    vertical-align: middle;
}

.WarningText {
    color: #dc3545;
    flex-basis: 100%;
    margin-top: .5rem;
    margin-bottom: .5rem;
}
</style>
<style scoped>
::v-deep .el-loading-mask {
    z-index: 1 !important;
}
.AdCustomKeyword-Slot {
    margin-bottom: 12px;
}
.AdCustomKeyword-SlotTitle {
    font-weight: 600;
    margin-top: 4px;
    margin-bottom: 2px;
}
.AdCustomKeyword-LangLabel {
    color: #606266;
    font-weight: 400;
    margin-top: 2px;
}
</style>